import { getCookie } from '../../DAL/storage-provider';
import { getGdprCookie } from '../../projects/gdpr/domain/gdpr-provider';

declare global {
    interface Window {
        global: {
            dal: {
                cookies: {
                    getCookie: (cookieName: string) => string | null;
                }
            },

            waves: {
                GDPRMarketing: () => boolean;
                GDPRPerformance: () => boolean;
                GDPRFunctional: () => boolean;
                GDPRMarketingConsentMode: () => string;
                GDPRPerformanceConsentMode: () => string;
                GDPRFunctionalConsentMode: () => string;
            },
        }
    }
}

export const initOldWebsiteCompatibility = () => {

    // var cookie = global.dal.cookies.getCookie('gdpr2');
    window.global = window.global || {};
    window.global.dal = window.global.dal || {};
    window.global.dal.cookies = window.global.dal.cookies || {};

    window.global.dal.cookies.getCookie = (cookieName: string) => {
        return getCookie(cookieName);
    };

    window.global.waves = window.global.waves || {};

    window.global.waves.GDPRMarketing = () : boolean => {
        return getGdprCookie().IsMarketing;
    };

    window.global.waves.GDPRFunctional = () : boolean => {
        return getGdprCookie().IsFunctional;
    };

    window.global.waves.GDPRPerformance = () : boolean => {
        return getGdprCookie().IsPerformance;
    };

    window.global.waves.GDPRMarketingConsentMode = () : string => {
        return getGdprCookie().IsMarketing ? 'granted' : 'denied';
    };

    window.global.waves.GDPRFunctionalConsentMode = () : string => {
        return getGdprCookie().IsFunctional ? 'granted' : 'denied';
    };

    window.global.waves.GDPRPerformanceConsentMode = () : string => {
        return getGdprCookie().IsPerformance ? 'granted' : 'denied';
    };
};